<template>
	<div class="detail-box round">
		<div class="pro">
			<p class="user-name">
				<small class="user-num">{{ member.mberId }}</small>
				{{member.mberName }}
				<br />
				<span
					class="user-label"
					v-for="auth in member.authAllotList"
					:key="`member-label-${hash(auth)}`"
					:style="auth.color ? `background: ${auth.color}`: ''"
				>{{auth.authName}}</span>
			</p>
			<div class="btn-group-box">
				<div class="btn-group text-center clearfix">
					<a
						class="btn-sm round detail text-red"
						@click="$router.push('/users/detail/' + member.mberId)"
					>상세보기</a>
					<a class="btn-sm round sms" @click="$emit('onSms')">문자 보내기</a>
					<!-- <a class="btn-sm round mail" @click="$emit('onEmail')">전자우편 보내기</a> -->
				</div>
			</div>
		</div>
		<!-- //end .pro -->
		<ul ref="proDetailTab" class="pro-detail-tab clearfix">
			<li class="on" data-tab-no="1">
				<a>회원정보</a>
			</li>
			<li data-tab-no="2">
				<a>수료/교육완료</a>
			</li>
		</ul>
		<div class="pro-detail" v-bind:class="{on:activatedTab==1}">
			<p class="pro-detail-tit">
				<span>회원정보</span>
			</p>
			<p class="pro-detail-con">
				연락처
				<small>{{ member.mobileNum }}</small>
			</p>
			<p class="pro-detail-con">
				이메일
				<small>{{ member.email }}</small>
			</p>
			<!-- <p class="pro-detail-con">
				직업
				<small>{{member.workCode}}</small>
			</p>
			<p class="pro-detail-con">
				소속기관
				<small>{{member.agency?member.agency.agencyName:''}}</small>
			</p> -->
			<!-- <p class="pro-detail-con">
				가입일
				<small>{{member.regDate | parseRegDate}}</small>
			</p> -->
			<!-- <p class="pro-detail-con">
				최근접속일
				<small>{{member.lastLoginDate | parseRegDate}}</small>
			</p> -->
		</div>
		<!-- //end .pro-detail -->
		<div class="pro-detail" v-bind:class="{on:activatedTab==2}">
			<p class="pro-detail-tit">
				<span>수료/교육완료 이력</span>
			</p>
			<p
				class="pro-detail-con"
				v-for="(item,idx) in applyList"
				:item="item"
				:index="idx"
				:key="'member-'+member.mberId+'-apply0list-'+idx"
			>
				{{item.lec.lecName}}
				<br>
				<span>{{item.regDate | parseRegDate}}</span>
				<span>{{item.applStatus}}</span>
				<!-- <span>{{item.certStatus}}</span> -->
				<!-- <small class="progress">
					<span class="progress-bar" :style="'width:'+item.progress+'%'">{{item.progress}}%</span>
				</small> -->
			</p>
			<p class="pro-detail-con" v-if="applyList.length==0">{{applyMsg}}</p>
		</div>
		<!-- //end .pro-detail -->
	</div>
	<!-- //end .detail-box -->
</template>

<script>
import fnAdjustLiWidth from "../mixins/fnAdjustLiWidth";
import axios from "axios";
import server from "../statics/server.js";
import moment from "moment";

export default {
	// 컴포넌트명
	name: "CtrlMemberSummary",
	mixins: [fnAdjustLiWidth],
	props: {
		member: Object
	},
	// 이 컴포넌트에서 사용될 내부 데이터 (=state)
	data: function() {
		return {
			activatedTab: 1, // 활성화된 탭 번호. 디폴트는 첫번째 탭이 활성화된 상태.
			applyList: [], // 수료/교육완료 이력
			applyMsg: "수강 신청내역이 없습니다."
		};
	},
	// 이 컴포넌트가 DOM에 마운트될 때, 탭을 구성하는 각 <LI>들의 개수에 따라 width를 계산해서 적용한다.
	mounted: function() {
		this.getApplyInfo(this.member.mberId);
	},

	watch: {
		member: function(newValue) {
			this.getApplyInfo(newValue.mberId);
		}
	},

	methods: {
		getApplyInfo: function(mberId) {
			this.applyList = [];
			this.applyMsg = "불러오는 중...";
			axios.post(server.addr() + server.api.APPL, { mberId }).then(response => {
				if (response.data.list.length == 0) {
					this.applyMsg = "수강 신청내역이 없습니다.";
				}
				this.applyList = response.data.list.map(i => {
					let totalPages = 0, viewedPages = 0, totalLength = 0, totalDuration = 0;
					if(i.lec.curriculumList && i.lec.curriculumList.length) {
						i.lec.curriculumList[0].lesList.forEach((lesMain) => {
							// 이 위치에서 lesMain은 차시에 해당하는 LES레코드임
							lesMain.child.forEach((les) => {
								totalPages += parseInt(les.connContPages);
								// 이 위치에서 les는 단원에 해당하는 LES레코드임
								les.lesProgressList.forEach((mem) => {
									// 이 위치에서 mem은 이 단원을 한번이라도 열람했던 회원의 LES_PROGRESS레코드임
									if(mem.mberId==this.member.mberId) {
										viewedPages += parseInt(mem.pageNum);
										totalLength += parseInt(mem.totalLength);
										totalDuration += (parseInt(mem.endTime) - parseInt(mem.startTime))/1000;
									}
								})
							})
						});
					} else {
						i.progress = 0;
					}
					if(viewedPages > totalPages) viewedPages = totalPages;
					if(totalLength==0) {
						i.progress = Math.round((viewedPages/totalPages)*100*10) / 10;
						if(!i.progress) i.progress = 0;
					} else {
						i.progress = totalDuration ? Math.round(((totalDuration * (viewedPages/totalPages)) / totalLength) * 100 * 10) / 10 : 0;
					}
					if(i.progress > 100) i.progress = 100;
					return i;
				});
			});
		}
	},

	filters: {
		parseRegDate(date) {
			return moment(date).format("YYYY-MM-DD");
		}
	}
};
</script>

<style scoped>
.user-label {
	background: #a0a0a0;
	padding: 0 5px;
	font-size: 0.65rem;
}
</style>